import { NavLink } from "react-router-dom";
import { Icon } from "~/components/base/Icon";
import { useT } from "~/hooks/useT";
import { useCartStore } from "~/stores/cartStore";

interface MobileNavItem {
  to: string;
  icon: string;
  labelKey: string;
  count?: number;
}

export function AppMobileNav() {
  const { t } = useT();
  const cartCount = useCartStore((s) => s.count());

  const items: MobileNavItem[] = [
    { to: "/dashboard", icon: "dashboard", labelKey: "dashboard" },
    { to: "/catalog", icon: "catalog", labelKey: "catalog" },
    { to: "/cart", icon: "cart", labelKey: "cart", count: cartCount },
    { to: "/orders", icon: "orders", labelKey: "orders" },
    { to: "/account", icon: "account", labelKey: "account" },
  ];

  return (
    <nav className="mobile-nav">
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          className={({ isActive }) =>
            `mobile-nav__item${isActive ? " mobile-nav__item--active" : ""}`
          }
        >
          <Icon name={it.icon} size={20} stroke={1.7} />
          <span className="mobile-nav__label">{t(it.labelKey)}</span>
          {typeof it.count === "number" && it.count > 0 && (
            <span className="mobile-nav__count num">{it.count}</span>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
